export enum FundChartOptionValue {
    DISPLAY_DATE_RANGE = 'displayDateRange',
    LEGEND_ON_CHART = 'legendOnChart',
    QUOTE_LEGEND = 'quoteLegend',
    DATA_IN_LEGEND = 'dataInLegend',
    SHOW_CUSTOM_COLORS = 'useCustomColors',
    SHOW_DATA_SOURCE = 'source',
    SHOW_FORWARD_ESTIMATES = 'useEstimates',
    NAME_IN_LEGEND = 'nameInLegend',
    SHOW_UNITS_IN_LEGEND = 'units',
    SHOW_US_RECESSIONS = 'recessions',
    USE_LOG_SCALE = 'scaleType',
    VALUE_FLAGS = 'valueFlags',
    SHOW_PERFORMANCE_DISCLOSURE = 'performanceDisclosure',
    CONVERT_CURRENCY = 'convertCurrency',
    CURRENCY = 'currency',
}

export enum FundChartSeriesType {
    security = 'security',
    securityList = 'security_list',
}

export enum CorrelationType {
    RATIO = 'ratio',
    SPREAD = 'spread',
    CORRELATION = 'correlation',
}

export enum FundChartAnnotationName {
    // text annotation
    TEXT = 'Text',

    // shape annotations
    CIRCLE = 'Circle',
    RECTANGLE = 'Rectangle',

    // line annotations
    TREND_SEGMENT = 'Trend Segment',
    ARROW_SEGMENT = 'Arrow Segment',
    RAY = 'Ray',
    ARROW_RAY = 'Arrow Ray',
    LINE = 'Line',
    ARROW_LINE = 'Arrow Line',
    PARALLEL_CHANNEL = 'Parallel Channel',
    HORIZONTAL_LINE = 'Horizontal Line',
    VERTICAL_LINE = 'Vertical Line',
}

export enum FundChartCursorType {
    CURSOR = 'cursor',
    CROSSHAIR = 'crosshair',
}

export enum DataInLegendOption {
    VALUE = 'value',
    ANNUALIZED_VALUE = 'annualized_value',
    VALUE_AND_ANNUALIZED_VALUE = 'value_and_annualized_value',
    NONE = 'none',
}

export enum ValueFlagOption {
    VALUE = 'value',
    TICKER = 'ticker',
    VALUE_AND_TICKER = 'value_and_ticker',
    NONE = 'none',
}
